import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center mb-10" }
const _hoisted_2 = {
  class: "nes-select is-dark flex-1",
  style: {"display":"none"}
}
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "nes-select is-dark flex-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  class: "text-gray-500",
  value: null
}, "Choose wallet..", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        required: "",
        id: "cluster",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chosenCluster) = $event))
      }, [
        _createElementVNode("option", {
          value: _ctx.Cluster.Mainnet
        }, "Mainnet", 8, _hoisted_3),
        _createElementVNode("option", {
          value: _ctx.Cluster.Devnet
        }, "Devnet", 8, _hoisted_4),
        _createElementVNode("option", {
          value: _ctx.Cluster.Testnet
        }, "Testnet", 8, _hoisted_5),
        _createElementVNode("option", {
          value: _ctx.Cluster.Localnet
        }, "Localnet", 8, _hoisted_6)
      ], 512), [
        [_vModelSelect, _ctx.chosenCluster]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _withDirectives(_createElementVNode("select", {
        required: "",
        id: "wallet",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chosenWallet) = $event))
      }, [
        _hoisted_8,
        _createElementVNode("option", {
          value: _ctx.WalletName.Phantom
        }, "Phantom", 8, _hoisted_9),
        _createElementVNode("option", {
          value: _ctx.WalletName.Sollet
        }, "Sollet", 8, _hoisted_10),
        _createElementVNode("option", {
          value: _ctx.WalletName.SolletExtension
        }, "Sollet Extension", 8, _hoisted_11),
        _createElementVNode("option", {
          value: _ctx.WalletName.Solflare
        }, "Solflare", 8, _hoisted_12),
        _createElementVNode("option", {
          value: _ctx.WalletName.SolflareWeb
        }, "Solflare Web", 8, _hoisted_13)
      ], 512), [
        [_vModelSelect, _ctx.chosenWallet]
      ])
    ])
  ]))
}